'use client';

import { c as _c } from "react/compiler-runtime";
import { CSSProperties } from 'react';
import { getOptimizedImagePath, getOptimizedImageSrcSet } from '../services/image-loader-service';
type MarkdownImageProps = {
  alt?: string;
  height?: number | string;
  src?: string;
  style?: CSSProperties;
  width?: number | string;
};
const DEFAULT_SIZES = '(max-width: 768px) 100vw, 768px';
export default function MarkdownImage(t0) {
  const $ = _c(12);
  const {
    alt: t1,
    height,
    src,
    style,
    width
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  if (!src || typeof src !== "string") {
    return null;
  }
  let t2;
  if ($[0] !== src) {
    t2 = getOptimizedImageSrcSet(src);
    $[0] = src;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const srcSet = t2;
  let t3;
  if ($[2] !== src) {
    t3 = getOptimizedImagePath(src, 800);
    $[2] = src;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const optimizedSource = t3;
  const t4 = srcSet ? DEFAULT_SIZES : undefined;
  let t5;
  if ($[4] !== alt || $[5] !== height || $[6] !== optimizedSource || $[7] !== srcSet || $[8] !== style || $[9] !== t4 || $[10] !== width) {
    t5 = <img src={optimizedSource} srcSet={srcSet} sizes={t4} alt={alt} width={width} height={height} style={style} loading="lazy" decoding="async" />;
    $[4] = alt;
    $[5] = height;
    $[6] = optimizedSource;
    $[7] = srcSet;
    $[8] = style;
    $[9] = t4;
    $[10] = width;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}